import { render, staticRenderFns } from "./move_action.vue?vue&type=template&id=69151fc6&scoped=true&"
import script from "./move_action.vue?vue&type=script&lang=js&"
export * from "./move_action.vue?vue&type=script&lang=js&"
import style0 from "./move_action.vue?vue&type=style&index=0&id=69151fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69151fc6",
  null
  
)

export default component.exports